export default __webpack_public_path__ + "static/Perfect1-9002c1548943b1df37ee8cb2a7f5799e.jpg";